<template>
  <div
    class="table"
    v-if="commissonsData && commissonsData.productList && commissonsData.productList.length"
    :class="{ 'hide-grade': commissonsData.hasProductGrade == '0' }"
  >
    <div class="table-row head border-bottom" :style="{ 'border-right': scrollWidth + 'px solid #F7F7F7' }">
      <div class="td big-td">险种名称</div>
      <div class="td big-td2">费率纬度</div>
      <div class="td">交费期</div>
      <div class="td">服务费分配</div>
      <div class="td" v-for="(num, i) in commissonsData.curBackList" :key="i" :class="{ hd: num == 99 }">
        <span v-if="num == 1">首年(%)</span>
        <span v-else-if="num == 99">首年活动(%)</span>
        <span v-else-if="num == 100">首年发放(%)</span>
        <span v-else-if="num == 101">首年后置(%)</span>
        <span v-else>{{ '第' + num + '年' }}(%)</span>
      </div>
    </div>
    <div class="table-row t-body" id="tBody">
      <span class="position-top title" v-if="positionTitle"><span class="fu-icon" v-if="positionIndex > 0">附</span>{{ positionTitle }}</span>
      <div class="box">
        <div
          class="table-row-child border-bottom"
          v-for="(item, i) in commissonsData.productList"
          :key="i"
          :class="{ 'hide-grade': commissonsData.hasProductGrade == '0' }"
        >
          <div class="merge-td big-td" :id="'title' + i">
            <span :class="{ hide: positionIndex == i && positionTitle }"> <span class="fu-icon" v-if="i > 0">附</span>{{ item.additionName }} </span>
          </div>
          <div class="box">
            <div class="table-row-child" v-for="(item2, ii) in item.list" :key="ii">
              <div class="merge-td big-td2">{{ item2.productGradeName || '--' }}</div>
              <div class="box">
                <div class="table-row-child" v-for="(item3, iii) in item2.commissionList" :key="iii">
                  <div class="td td3h">{{ item3.payTermTxt }}</div>
                  <div class="td td3h">
                    <div class="td">一级机构</div>
                    <div class="td">费率比</div>
                    <div class="td">{{ formData.type == '1' ? '团队' : '员工' }}</div>
                  </div>
                  <div class="td td3h" v-for="(item4, iiii) in item3.list" :key="iiii">
                    <div class="td" :class="{ subsidy: item4.curBack == 99 && !item4.isEmpty, hd: item4.curBack == 99 }">
                      <span>{{ item4.parentCommission ? item4.parentCommission : '--' }}</span>
                    </div>
                    <div class="td" :class="{ subsidy: item4.curBack == 99 && !item4.isEmpty, hd: item4.curBack == 99 }">
                      <span>{{ item4.rate ? item4.rate : '--' }}</span>
                    </div>
                    <div class="td" :class="{ subsidy: item4.curBack == 99 && !item4.isEmpty, hd: item4.curBack == 99 }">
                      <span>{{ item4.commission ? item4.commission : '--' }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <emptyBox slot="empty" v-else></emptyBox>
</template>
<script>
import { data } from "./config.js";
export default {
  props: ['formData'],
  data: () => ({
    commissonsData: {},
    positionTitle: "",//当前定位的标题
    positionIndex: 0,//当前定位的标题序号
    scrollWidth: 0,//滚动条宽度
  }),
  components: {
  },
  mounted() {
  },
  methods: {
    // 设置数据
    setData(data) {
      if (data.activityName) {
        data.curBackList.splice(1, 0, 99);
      }
      if (data.isNjJdProduct) {//首年费用后置占位
        data.curBackList.splice(1, 0, 100)
        data.curBackList.splice(1, 0, 101)
      }
      data.productList.forEach(item => {
        item.list.forEach(item2 => {
          item2.commissionList.forEach(item3 => {
            let list = [];
            data.curBackList.forEach(item4 => {
              let bean = {
                isEmpty: true,
                curBack: item4
              };
              if (item4 == 99) {//活动tab
                item3.commissions.forEach(item5 => {
                  if (item5.subsidyCommissonsId) {
                    bean = item5;
                    bean.curBack = 99;
                  }
                });
              } else if (item4 == 100) {//首年发放费用
                bean.parentCommissionVal = item3.commissions[0].parentAfterPostfRateVal || ''//一级机构
                bean.commissionVal = item3.commissions[0].afterPostfRateVal || ''//二级团队
              } else if (item4 == 101) {//首年后置费用
                bean.parentCommissionVal = item3.commissions[0].parentPostfRateVal || ''//一级机构
                bean.commissionVal = item3.commissions[0].postfRateVal || ''//二级团队
                bean.rateVal = item3.commissions[0].rateVal || ''//费率比
              } else {
                item3.commissions.forEach(item5 => {
                  if (item4 == item5.curBack && !item5.subsidyCommissonsId) {
                    bean = item5;
                  }
                });
              }
              bean.oldRate = bean.rate = bean.rateVal;
              bean.oldCommission = bean.commission = bean.commissionVal ? bean.commissionVal * 1 : 0;
              bean.parentCommission = bean.parentCommissionVal;
              list.push(bean);
            });
            this.$set(item3, 'list', list);
          });
        });
      });
      this.commissonsData = data;
      this.positionTitle = "";//当前定位的标题
      this.positionIndex = "";//当前定位的标题序号
      setTimeout(() => {
        const tBody = document.getElementById("tBody");
        let offsetHeight = 0;
        this.commissonsData.productList.forEach((item, i) => {
          const title = document.getElementById("title" + i);
          offsetHeight += title.offsetHeight
          item.offsetHeight = offsetHeight;
        });
        if (tBody) {
          tBody.removeEventListener("scroll", this.jisuanH, false);
          tBody.addEventListener("scroll", this.jisuanH, false);
          // 判断是否有滚动条占位
          if (tBody.offsetWidth != tBody.clientWidth) {
            this.scrollWidth = tBody.offsetWidth - tBody.clientWidth;
          } else {
            this.scrollWidth = 0;
          }
        }

      }, 200);
    },
  },
};
</script>
<style lang="scss" scoped>
@import './feeTable.scss';
</style>

